import React, {Component} from 'react';

class JSHeader extends Component {

    render() {
        const {companyName} = this.props;

        return (
            <div className="blue-bg header">
                <div className="general-width margin-width-auto padding-top-x-small padding-bottom-x-small">
                    <label className="xx-large white">{companyName}</label>
                </div>
            </div>
        );
    }
}
export default JSHeader